import { render } from "./PeopleProfile.vue?vue&type=template&id=e1014528&scoped=true"
import script from "./PeopleProfile.vue?vue&type=script&lang=js"
export * from "./PeopleProfile.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=e1014528&lang=sass&scoped=true"
import "@/assets/css/loading.sass?vue&type=style&index=1&id=e1014528&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1014528"]])

export default __exports__